import { Route, Routes, useNavigate } from 'react-router-dom'

import PageLoader from 'Components/PageLoader'

import { useGetAppQuery } from './happyfox-helpdesk.service'

import InstallHappyFoxHelpdesk from './InstallHappyFoxHelpdesk'
import ManageHappyFoxHelpdesk from './ManageHappyFoxHelpdesk'
import HappyFoxHelpDeskAuthenticateForm from './HappyFoxHelpDeskAuthenticateForm'

const HappyFoxHelpdesk = () => {
  const { isLoading, data: app = {} } = useGetAppQuery()
  const navigate = useNavigate()

  if (isLoading) {
    return <PageLoader />
  }

  if (!app.is_linked) {
    return <InstallHappyFoxHelpdesk app={app} />
  }

  const handleAuthFormCancel = () => {
    navigate('./')
  }

  return (
    <Routes>
      <Route
        path='auth'
        element={
          <HappyFoxHelpDeskAuthenticateForm onCancel={handleAuthFormCancel} onAuth={handleAuthFormCancel} app={app} />
        }
      />
      <Route path='*' element={<ManageHappyFoxHelpdesk app={app} />} />
    </Routes>
  )
}

export default HappyFoxHelpdesk
